/**
 * Map ID for Advanced Markers (Maps JavaScript API).
 * Create in Google Cloud Console → Google Maps Platform → Map Management.
 * In local dev, falls back to Google's DEMO_MAP_ID when unset.
 */
export function resolveGoogleMapId(): string {
  const configured = import.meta.env.VITE_GOOGLE_MAP_MAP_ID?.trim();
  if (configured) {
    return configured;
  }
  if (import.meta.env.DEV) {
    return 'DEMO_MAP_ID';
  }
  return '';
}
